import EnvVars from 'helpers/envVars';

const domainImages = EnvVars('API_IMAGES_BASE_URL');

export default ({ id, vcode }) => {
  return `${domainImages}/audio-video/v1.0/${id}${
    vcode ? `?vcode=${vcode}` : ''
  }`;
};
